
import { m, LazyMotion, domAnimation } from "framer-motion";
import EmojiDisplay from "../animation/emojis/EmojiDisplay";
import { useState, useEffect } from "react";
import AnimatedLetter from "../animation/text/AnimatedLetter";

const emojis = [
  {
    key: "1f600",
    value: "😀"
  },
  {
    key: "1f60a",
    value: "😊"
  },
  {
    key: "1f979",
    value: "🥹"
  },
  {
    key: "1fae0",
    value: "🫠"
  },
  {
    key: "1f60d",
    value: "😍"
  },
  {
    key: "1f601",
    value: "😁"
  },
  {
    key: "1f60e",
    value: "😎"
  },
  {
    key: "1f978",
    value: "🥸"
  },
]

const LandingText = () => {
  const name = "Ricardo";

  // const [emoji, setEmoji] = useState(emojis[Math.floor(Math.random() * emojis.length)]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setEmoji(emojis[Math.floor(Math.random() * emojis.length)]);
  //   }, 10000);

  //   // Clear interval on component unmount
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []); 


  return (
    <div
      className="noselect w-fit h-fit text-primary-200 absolute z-10 flex flex-col justify-center items-center rounded-[60%] drop-shadow-green"
      id="repulse-div"
    >
      <LazyMotion features={domAnimation} strict>
        <m.h1
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, type: "spring" }}
          className="text-center flex justify-center items-center flex-col opacity-100 text-4xl sm:text-9xl cursor-default"
          style={{ fontFamily: "SuperMario" }}
        >

          <m.span
            initial={{ x: -100 }}
            whileInView={{ x: 0 }}
            transition={{ duration: 0.6, type: "spring" }}
            className="text-secondary-600 text-6xl select-none"
          >
            IT'S A ME...{" "}
          </m.span>

          <m.div // TODO: refactor animatedText to use this
            initial={{ x: 100 }}
            whileInView={{ x: 0 }}
            transition={{ duration: 0.6, type: "spring" }}
          >
            {name.split("").map((char, index) => AnimatedLetter({ char, index, className: "text-primary-700 inline-block select-none", fontSize: "1.2em", tap: { scale: 1.1, rotate: -30, borderRadius: "0%" } }))}
          </m.div>
          

          {/* <m.div
            initial={{ x: 300 }}
            whileInView={{ x: 0 }}
            transition={{ duration: 2.8, type: "spring" }}
            className="ml-10"
          >

            <EmojiDisplay selectedEmoji={emoji} />


          </m.div> */}

          <m.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7, type: "spring" }}
            className="mt-4 text-center text-sm sm:text-base text-primary-500 italic max-w-xs select-none"
            style={{ fontFamily: "SuperMario" }}
          >
          (Not quite a plumber, but I still fix things.)
          </m.p>


        </m.h1>
      </LazyMotion>
    </div>
  );
};

export default LandingText;